"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RandomGThumbnail = exports.generateDefaultThumb = exports.generateRandomThumb = void 0;
const react_1 = __importDefault(require("react"));
const pink_thumb_png_1 = __importDefault(require("./images/pink-thumb.png"));
const blue_thumb_png_1 = __importDefault(require("./images/blue-thumb.png"));
const yellow_thumb_png_1 = __importDefault(require("./images/yellow-thumb.png"));
const green_thumb_png_1 = __importDefault(require("./images/green-thumb.png"));
const generateRandomThumb = () => {
    const thumbs = [pink_thumb_png_1.default, blue_thumb_png_1.default, yellow_thumb_png_1.default, green_thumb_png_1.default];
    return thumbs[Math.floor(Math.random() * thumbs.length)];
};
exports.generateRandomThumb = generateRandomThumb;
const generateDefaultThumb = () => {
    return blue_thumb_png_1.default;
};
exports.generateDefaultThumb = generateDefaultThumb;
const RandomGThumbnail = () => {
    return react_1.default.createElement("img", { src: (0, exports.generateRandomThumb)(), alt: "g-thumb" });
};
exports.RandomGThumbnail = RandomGThumbnail;
//# sourceMappingURL=random-g-thumbnail.js.map